// Types
import { ISystemSettingsMappedPayItem, ISystemSettingsPayItem } from "@/Settings/types/PayrollMapping/api";
import { ISystemSettingsCustomField, ISystemSettingsMappedCustomField } from "@/Settings/types/PayrollMapping/CustomFieldItemsMapping/api";

function isLastInputFulfilled(inputs: Array<ISystemSettingsCustomField | ISystemSettingsPayItem>): boolean {
	if (!inputs?.length) {
		return true; // If no inputs, consider it fulfilled to display 'Plus' button enabled
	}
	const lastInput = inputs[inputs.length - 1];

	// Check displayId first
	if (lastInput.displayId === "") {
		return false;
	}

	// Check fieldName or name property
	if ("fieldName" in lastInput) {
		return lastInput.fieldName !== "";
	} else if ("name" in lastInput) {
		return lastInput.name !== "";
	}

	return false;
}

function areAllInputsFulfilled(allMappedItems: Array<ISystemSettingsMappedCustomField | ISystemSettingsMappedPayItem>): boolean {
	return allMappedItems.every((item) => {
		const inputs = "payrollCustomFields" in item ? item.payrollCustomFields : item.payrollPayItems;
		if (!inputs || !Array.isArray(inputs)) {
			return true; // If no inputs, consider it fulfilled
		}
		return inputs.every((input) => {
			if (input.displayId === "") {
				return false;
			}
			if ("fieldName" in input) {
				return input.fieldName !== "";
			} else if ("name" in input) {
				return input.name !== "";
			}
			return false;
		});
	});
}

export { isLastInputFulfilled, areAllInputsFulfilled };
